/** "Check the arithmetic": the three reconciliation lines of R7, each from figures the page already prints (see `reconcile.ts`). Draws nothing when none has anything to say. */
import type { ContentCatalog, RoundReport } from "@bsim/contracts";
import { GxCard } from "../theme/primitives";
import { headlinesToFinale, payoutSplit, pricedToCounted, splitDefinitions, type YearReports } from "./reconcile";

export function Reconciliation({ years, report, catalog, isFinal }: { readonly years: readonly YearReports[]; readonly report: RoundReport; readonly catalog: ContentCatalog; readonly isFinal: boolean }) {
  const finale = isFinal ? headlinesToFinale(years, catalog) : null;
  const payouts = payoutSplit(years, report, catalog);
  const cards = pricedToCounted(report);
  const defs = splitDefinitions(report);
  if (finale === null && payouts === null && cards.length === 0 && defs === null) return null;
  const block = (testId: string, title: string, lines: readonly string[]) => (
    <div data-testid={testId}><b className="gx-small">{title}</b>{lines.map((l, i) => <p key={i} className="gx-small gx-num">{l}</p>)}</div>
  );
  return (
    <GxCard title="Check the arithmetic" testId="results.reconcile">
      <div className="gx-card-b gx-results-stack">
        {finale === null ? null : block("results.reconcile.finale", "Yearly scores to the finale", finale)}
        {payouts === null ? null : block("results.reconcile.payouts", "Dividends and buybacks", payouts)}
        {defs === null ? null : block("results.reconcile.split", "What moved the year's score", defs)}
        {cards.length === 0 ? null : block("results.reconcile.cards", "Cards: priced, then counted", cards)}
      </div>
    </GxCard>
  );
}
